// test1763
(1763 && 0);
